import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ro from './locales/ro.json'

const i18n = createI18n({
    legacy: false, // Use Composition API mode
    locale: 'ro', // default locale
    fallbackLocale: 'en',
    messages: {
        en,
        ro
    },
    globalInjection: true // allows simple usage like $t in templates
})

export default i18n
